export default [
  [`Размеры`, `6XS`, `5XS`, `4XS`, `3XS`, `2XS`, `XS`, `S`],
  [`Ширина, см`, `29`, `31`, `34`, `37`, `40`, `43`, `46`],
  [`Длина, см`, `42`, `45`, `48`, `51`, `54`, `57`, `60`]
];
